import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { AuthService } from './services/auth/auth.service';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  standalone: true,
  imports: [RouterOutlet],
  template: '<router-outlet></router-outlet>\n',
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    private auth: AuthService,
  ) { }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      // // Refetch the Auth0 profile for changes to the client:
      // this.auth.getUserProfile
      window.scrollTo(0, 0);
    });
  }
}
